import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {Linear, TweenLite} from "gsap"
import {Emitter} from "pixi-particles";

require("pixi-particles");

export class TweenParticleEmitter extends PIXI.Container {

    private configs:any[] = [
        // landscape
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.7,
                "end" : 0.7,
                "minimumScaleMultiplier" : 0.5
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 1000,
                "end" : 1000,
                "minimumSpeedMultiplier" : 1.3
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1500
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : -110,
                "max" : -70
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : -400,
                "max" : 400
            },
            "lifetime" : {
                "min" : 2.1,
                "max" : 2.1
            },
            "blendMode" : "normal",
            "frequency" : 0.002,
            "emitterLifetime" : 0.1,
            "maxParticles" : 50,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -100,
                "y" : -25,
                "w" : 200,
                "h" : 50
            }
        },
        // portrait
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.7,
                "end" : 0.7,
                "minimumScaleMultiplier" : 0.5
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 1200,
                "end" : 1200,
                "minimumSpeedMultiplier" : 1.3
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1500
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : -110,
                "max" : -70
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : -400,
                "max" : 400
            },
            "lifetime" : {
                "min" : 2.1,
                "max" : 2.1
            },
            "blendMode" : "normal",
            "frequency" : 0.002,
            "emitterLifetime" : 0.1,
            "maxParticles" : 50,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -100,
                "y" : -25,
                "w" : 200,
                "h" : 50
            }
        }
    ];

    private _emitters:Emitter[];
    private _activeEmitter:Emitter;

    public set maxParticles(value:number) {
        this._emitters.forEach((emitter:Emitter) => {
            emitter.maxParticles = value;
        })
    }

    public set orientation(value:Orientation) {
        this._activeEmitter = value === Orientation.PORTRAIT ? this._emitters[1] : this._emitters[0];
    }

    constructor(textures:PIXI.Texture[]) {
        super();
        this._emitters = [this.createEmitter(0, textures), this.createEmitter(1, textures)];
    }

    private createEmitter(index:number, textures:PIXI.Texture[]):Emitter {
        const emitter:Emitter = new Emitter(this, textures, this.configs[index]);
        ParticlesManager.addEmitter(emitter, false);
        return emitter;
    }

    public getAnimation(ease:any = Linear.easeNone):void {
        if(!this._activeEmitter) {
            this._activeEmitter = this._emitters[0];
        }

        this._activeEmitter.emit = true;
    }
}